import React, { useEffect, useRef } from "react";
import { Container } from "react-bootstrap";
import { baseURL, headers } from "../../../../../global/api";
import { connect } from "react-redux";
import { setHeading } from "../../../accounts/account.actions";
import { useNavigate } from "react-router-dom";
import { DeleteOrderApi, generateOrderPDF, getOrderById, updateOrder } from "./OrderBookingAction";
import { changeDateFormate, PDFHeader } from "../../../../../global/globalFunctions";
import MaterialTable from "material-table";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import jsPDF from 'jspdf';
import 'jspdf-autotable';


const ViewOrderBooking = (props) => {
  const navigate = useNavigate();
  const tableRef = useRef();
  function updateTableQuery() {
    tableRef.current.onQueryChange()
  };

  useEffect(() => {
    props.setHeading("Order Booking List");
  }, []);

  return (
    <>
      <Container fluid>
        <MaterialTable
          tableRef={tableRef}
          title="Order Booking List"
          columns={[
            { title: "S.No", field: "number", editable: "never" },
            { title: "Area Name", field: "areaId.areaName", editable: "never", },
            { title: "Shop Name", field: "shopId.shopName", editable: "never", },
            { title: "Date", field: "orderDate", render: (rowData) => changeDateFormate(rowData.orderDate), editable: "never", },
            { title: "DSF", field: "bookerId.userName" },
            { title: "Status", field: "status" },
            { title: "Sub Total", field: "subTotal" },
            { title: "Discount", field: "discount" },
            // { title: "Trade Offer", field: "tradeOffer" },
            { title: "Tax Amount", field: "taxAmount" },
            { title: "Grand Total", field: "grandTotal" },
            { title: 'Created By', field: 'userDetails.userName', editable: 'never' },
          ]}
          data={(query) =>
            new Promise((resolve, reject) => {
              let url = `${baseURL}/booking?`;
              url += "limit=" + query.pageSize;
              url += "&page=" + query.page;
              url += "&search=" + query.search;
              fetch(url, {
                method: "GET",
                headers: headers,
              }).then((response) => response.json()).then((result) => {
                resolve({
                  data: result.data,
                  page: result.page,
                  totalCount: result.total_results,
                });
              });
            })
          }
          editable={{
            onRowDelete: (oldData) =>
              new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  props.DeleteOrderApi(oldData._id, updateTableQuery);
                }, 600);
              }),
          }}
          icons={{
            Delete: (props) => <DeleteOutlineIcon {...props} style={{ color: "#DC3545" }} />
          }}
          detailPanel={(rowData) => {
            return (
              <MaterialTable
                columns={[
                  // { title: "Code", field: "code", editable: 'never' },
                  { title: "Product Name", field: "productLabel", editable: 'never' },
                  { title: "Quantity", field: "quantity", },
                  { title: "Product Sale Price", field: "salePrice", editable: 'never' },
                  { title: "Total Sale Amount", render: (rowData) => Number(rowData.quantity) * Number(rowData.salePrice) },
                ]}
                data={rowData.items}
                options={{
                  toolbar: false,
                  search: false,
                  actionsColumnIndex: -1,
                  exportButton: false,
                  exportAllData: false,
                  paging: false,
                  pageSize: 50,
                  emptyRowsWhenPaging: false,
                  pageSizeOptions: [50, 100, 150, 200],
                  headerStyle: {
                    position: "sticky",
                    top: 0,
                    color: "#00BBBB",
                    fontWeight: "550",
                    fontSize: "14px",
                  },
                  rowStyle: (rowData, index) => ({
                    backgroundColor: "#ededed",
                    // fontWeight: rowData.accountType === 1 ? "bold" : "normal",
                    color: "black"
                  }),
                }}
              />
            );
          }}
          options={{
            actionsColumnIndex: 0,
            exportButton: true,
            exportAllData: true,
            paging: true,
            pageSize: 50,
            emptyRowsWhenPaging: false,
            pageSizeOptions: [50, 100, 150, 200],
            headerStyle: {
              position: "sticky",
              top: 0,
              color: "#00BBBB",
              fontWeight: "550",
              onRowAdd: "none",
              whiteSpace: 'nowrap',
            },
            rowStyle: {
              whiteSpace: 'nowrap',
            },
            cellStyle: {
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            },
            exportPdf: (columns, data) => {
              const unit = "pt";
              const size = "A4";
              const orientation = "l";
              const doc = new jsPDF(orientation, unit, size);
              PDFHeader(doc, "Booking Details");

              const columnTitles = columns.map(columnDef => columnDef.title);
              const pdfData = data.map((elt) => [
                elt.number,
                elt.areaId.areaName,
                elt.shopId.shopName,
                changeDateFormate(elt.orderDate),
                elt.bookerId.userName,
                elt.status,
                elt.subTotal,
                elt.discount,
                // elt.tradeOffer,
                elt.taxAmount,
                elt.grandTotal,
              ]);
              let content = {
                startY: 120,
                startX: 5,
                head: [columnTitles],
                body: pdfData,
                headStyles: { fillColor: "#2980ba", font: 'Amiri', fontSize: 10 },
                styles: { fontSize: 9 },
                theme: "grid",
              };

              doc.setFontSize(11)
              doc.setFont("Times New Roman", "Normal")
              doc.autoTable(content);

              doc.setProperties({ title: 'Booking Details' })
              doc.output('dataurlnewwindow')
            },
          }}
          actions={[
            {
              icon: "refresh",
              tooltip: "Refresh Data",
              isFreeAction: true,
              onClick: () => tableRef.current && tableRef.current.onQueryChange(),
            },
            {
              icon: () => <PictureAsPdfIcon />,
              tooltip: "Generate PDF",
              onClick: (event, rowData) => {
                props.generateOrderPDF(rowData);
              },
            },
            (rowData) => ({
              icon: () => <EditIcon />,
              tooltip: "Edit Booking",
              // disabled: true,
              onClick: async (event, rowData) => {
                navigate(`/inventory/order-bookings/edit`);
                props.getOrderById(rowData._id)
              },
            }),
          ]}
        />
      </Container>
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    DeleteOrderApi: (id, updateTableQuery) => dispatch(DeleteOrderApi(id, updateTableQuery)),
    getOrderById: (id) => dispatch(getOrderById(id)),
    setHeading: (data) => dispatch(setHeading(data)),
    generateOrderPDF: (orderData) => dispatch(generateOrderPDF(orderData)),
    updateOrder: (data, oldData, rowData, updateTableQuery) => dispatch(updateOrder(data, oldData, rowData, updateTableQuery)),
  };
};
const mapStateToProps = (state, ownProps) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(ViewOrderBooking);